import { UserSettings } from '@paragon/contract-library';

import { DesignService } from '../connections';

export function getUserSettings(): Promise<UserSettings> {
  return DesignService.get(`userSettings`);
}

export function getUserSettingsForStation(stationGuid: string): Promise<UserSettings> {
  return DesignService.get(`stations/${stationGuid}/userSettings`);
}

export function postSetUserSettings(settings: UserSettings): Promise<UserSettings> {
  return DesignService.post(`userSettings`, { data: settings });
}

export function postSetUserSettingsForStation(stationGuid: string, settings: UserSettings): Promise<UserSettings> {
  return DesignService.post(`stations/${stationGuid}/userSettings`, { data: settings });
}
